import Helpers from "@/lib/helpers";

// while an answer is being written somewhere, look again this often
const CHAT_POLL_MS = 4000
let chatTimer = null

const state = {
    offers: null,
    messages: null,
    notifications: null,
    chat: null,
    // chats still being answered or with an answer not yet read, each with `running` and `context`
    chatActive: [],
}

const getters = {
    get_badge: (state) => (badge) => {
        return state[badge]
    },
    chat_active: (state) => state.chatActive,
    chat_working: (state) => state.chatActive.some(c => c.running),
    chat_ready: (state) => state.chatActive.some(c => c.unread && !c.running),
}

const mutations = {
    set_badge: (state, payload)  => {
        state[payload.badge] = payload.value
    },
    set_chat_active: (state, rows) => {
        state.chatActive = rows
        state.chat = rows.filter(c => c.unread).length || null
    }
}

const actions = {
    // What the assistant is doing in the background, for the navbar icon. Polls only while
    // something is being answered, so a finished answer shows up without a page change.
    async chat_load({commit, getters, dispatch}) {
        clearTimeout(chatTimer)
        chatTimer = null
        try {
            const r = await Helpers.asyncAction('/api/chat/conversation', 'get', {params: {active: 1}, quiet: true, noload: true})
            commit('set_chat_active', r.conversations || [])
        } catch (e) {
            return
        }
        if (getters.chat_working)
            chatTimer = setTimeout(() => dispatch('chat_load'), CHAT_POLL_MS)
    },

    async badges_load({getters, commit, dispatch}) {
        const badges = {}

        await Helpers.asyncAction('/api/user/self/notification/count', 'get', {
            quiet: true,
            noload: true
        }).then(({count}) => commit('set_badge', {badge: 'notifications', value:  (count > 100 ? '99+' : count)}))
            .catch()

        if (getters.can('offers.read') && getters.can('offers.index'))
            Helpers.asyncAction('/api/offer', 'get', {
                params: {count: true, filter: 'seller'},
                quiet: true,
                noload: true
            }).then(({count}) => commit('set_badge', {badge: 'offers', value: ((count > 100 ? '99+' : count))}))
                .catch()

        if (getters.can('chat.use'))
            dispatch('chat_load')

        if ((getters.can('messages.read') && getters.can('messages.index')) || getters.can('messages.self'))
            Helpers.asyncAction('/api/message', 'get', {
                params: {count: true, filter: 'myassigned'},
                quiet: true,
                noload: true
            }).then(({count}) => commit('set_badge', {badge: 'messages', value: count })) //(count > 100 ? '99+' : count)}))
                .catch()
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}